import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingDetailsModule } from './building-details/building-details.module';
import { BuildingListModule } from './building-list/building-list.module';
import { BuildingUnitDetailsModule } from './building-unit-details/building-unit-details.module';
import { AddBuildingDetailsComponent } from './add-building-details/add-building-details.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { FloorManagementModule } from '../floor-management/floor-management.module';
import { SharedLayoutModule } from '../shared-layout/shared-layout.module';
import { AccessControlModule } from '../libs/ui/directives/access-control/access-control.module';
import { ControlDisabledDirectiveModule } from '../libs/ui/directives/control-disabled/control-disabled-directive.module';
import { SortByModule } from '../libs/ui/pipes/sort-by/sort-by.module';
import {
  MatAutocompleteModule,
  MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
} from '@angular/material/autocomplete';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CloseScrollStrategy, Overlay } from '@angular/cdk/overlay';
import { DeviceSettingsModule } from './device-settings/device-settings.module';
import { SelectSiteModule } from './select-site/select-site.module';
import { WithTooltipModule } from '../shared-layout/Components/with-tooltip/with-tooltip.module';
import { LocalizationService } from '../shared/services/localization.service';
import { TranslateModule } from '@ngx-translate/core';

export function scrollFactory(overlay: Overlay): () => CloseScrollStrategy {
  return () => overlay.scrollStrategies.close();
}

@NgModule({
  declarations: [AddBuildingDetailsComponent],
  imports: [
    CommonModule,
    BuildingDetailsModule,
    BuildingListModule,
    BuildingUnitDetailsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    NgbModule,
    HttpClientModule,
    FloorManagementModule,
    SharedLayoutModule,
    WithTooltipModule,
    ControlDisabledDirectiveModule,
    AccessControlModule,
    SortByModule,
    MatAutocompleteModule,
    ScrollingModule,
    TranslateModule
  ],
  exports: [
    BuildingDetailsModule,
    BuildingListModule,
    BuildingUnitDetailsModule,
    AddBuildingDetailsComponent,
    SelectSiteModule,
    DeviceSettingsModule,
  ],
  providers: [
    {
      provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
      useFactory: scrollFactory,
      deps: [Overlay],
    },
    LocalizationService,
    TranslateModule
  ],
})
export class BuildingManagementModule {}
